// extracted by mini-css-extract-plugin
module.exports = {"section":"styles-module--section--2Wb__","bold":"styles-module--bold--3Cf3L","header":"styles-module--header--1hoAR","list":"styles-module--list--pIlDg"};